import React, { useState, useEffect } from 'react';
import Routes from './routes';
import { createMuiTheme, ThemeProvider, makeStyles } from '@material-ui/core/styles';
import { ptBR } from '@material-ui/core/locale';
import theme from './components/layout/theme';

const tema = theme();

const materialTheme = createMuiTheme({
  palette: {
    primary: {
      main: tema.theme.primary,
    },
    secondary: {
      main: tema.theme.secondary,
      contrastText: '#fff',
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
  }
}, ptBR);

const useStyles = makeStyles(theme => ({
  alertaOffline: {
    backgroundColor: "#F32013",
    color: "#FFFFFF",
    textAlign: "center"
  }
}))

function App() {
  let [online, isOnline] = useState(navigator.onLine);

  const classes = useStyles();

  const setOnline = () => {
    isOnline(true);
  }

  const setOffline = () => {
    isOnline(false);
  }
  useEffect(() => {
    window.addEventListener('offline', setOffline);
    window.addEventListener('online', setOnline);
    return () => {
      window.removeEventListener('offline', setOffline);
      window.removeEventListener('online', setOnline);
    }
  }, []);
  return (
    <ThemeProvider theme={materialTheme}>
      {!online && <div className={classes.alertaOffline}>Sem conexão {online}</div>}
      <Routes />
    </ThemeProvider>
  );
}

export default App;
